
import { defineComponent } from "vue";

export default defineComponent({
    name: "App",
    setup() {
        const user: any = {
            name: "abc",
            age: "18",
            a: {
                b: [0]
            }
        };
        // 目标对象变成代理对象
        // 参数一：目标对象
        // 参数二：处理器对象，用来监视数据，及数据的操作
        const proxyUser = new Proxy(user,{
            // 获取目的对象的某个属性值
            get(target,prop) {
                console.log('get----');
                return Reflect.get(target,prop)
            },
            // 修改目标对象的属性值/为目标对象添加新的属性
            set(target,prop,val) {
                console.log('set----');
                return Reflect.set(target,prop,val);
            },
            deleteProperty(target,prop) {
                console.log('delete----');
                return Reflect.deleteProperty(target,prop);
            }
        })

        proxyUser.name = '123';
        console.log(proxyUser);

        proxyUser.gender = '男';
        console.log(proxyUser);

        delete proxyUser.name;
        console.log(proxyUser);

        proxyUser.a.b.push(1);
        console.log(proxyUser);

        return {
            proxyUser,
        };
    },
});
